import * as React from 'react';
// Lucide Icons
import { Mail, Phone } from 'lucide-react';
import { Trans } from '@lingui/react/macro';

import { IMAGES, getImage } from '../utils';
import { Button } from './ui/button';

const GoogleIcon = getImage(IMAGES.GOOGLE_ICON.ref);
const AppleIcon = getImage(IMAGES.APPLE_BUTTON.ref);

export const GoogleButton = ({ onClick, isSignIn = true }: { onClick: () => void; isSignIn: boolean }) => (
  <Button onClick={onClick} size="lg" variant="outline" className="w-full h-12">
    <img src={GoogleIcon} className="h-11 w-auto absolute left-1 " />
    <span>{isSignIn ? <Trans>Sign in with Google</Trans> : <Trans>Sign up with Google</Trans>}</span>
  </Button>
);

export const AppleButton = ({ onClick, isSignIn = true }: { onClick: () => void; isSignIn: boolean }) => (
  <Button onClick={onClick} size="lg" variant="outline" className="w-full h-12 relative">
    <img src={AppleIcon} className="h-4/7 w-auto absolute left-4 mb-1" />
    <span>{isSignIn ? <Trans>Sign in with Apple</Trans> : <Trans>Sign up with Apple</Trans>}</span>
  </Button>
);

export const PhoneButton = ({ onClick, isSignIn = true }: { onClick: () => void; isSignIn: boolean }) => (
  <Button onClick={onClick} size="lg" variant="outline" className="w-full h-12 relative">
    <Phone className="w-auto h-5 absolute left-4" style={{ color: '#1977f2' }} />
    <span>{isSignIn ? <Trans>Sign in with Phone</Trans> : <Trans>Sign up with Phone</Trans>}</span>
  </Button>
);

export const EmailButton = ({ onClick, isSignIn = true }: { onClick: () => void; isSignIn: boolean }) => (
  <Button onClick={onClick} size="lg" variant="outline" className="w-full h-12 relative">
    <Mail className="w-auto h-5 absolute left-4" style={{ color: '#1977f2' }} />
    <span>{isSignIn ? <Trans>Sign in with Email</Trans> : <Trans>Sign up with Email</Trans>}</span>
  </Button>
);
